import React, { useEffect, useState } from "react";
import { Avatar, Divider, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import message from "../../assets/Header/Message.svg";
import axios from "axios";
import { IoMdNotifications } from "react-icons/io";
import logoCrazzy from "../../assets/crazzy-hub.png";

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const email = localStorage.getItem("email");
  const [data, setData] = useState(false);
  const superuserId = localStorage.getItem("is_superuser");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    navigate("/");
    localStorage.clear();
  };
  // const handleLogoutReseller = () => {
  //   axios
  //     .post(
  //       `https://app1.crazzyhub.com/reseller_app/reseller-log-out/`,
  //       {
  //         email: email,
  //       },
  //       {
  //         headers: {
  //           Authorization: localStorage.getItem("token"),
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       localStorage.clear();
  //       navigate("/");
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       toast.error(error.data.message);
  //     });
  // };

  const Logo = () => {
    axios
      .get(
        `https://app1.crazzyhub.com/api/admin/multi-vendor-my-profile/`,

        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setData(response?.data?.data?.profile_data[0]);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    Logo();
  }, []);

  return (
    <>
      <div className="flex flex-row h-16 shadow bg-white border-white sticky top-0">
        <div
          className="flex items-center border-b-0 border-r z-50 sticky border-gray-300 "
          style={{
            width: "18%",
            background: "linear-gradient(180deg, #F5A268, #F70000)",
          }}
        >
          <div className="m-5">
            <img
              src={logoCrazzy}
              alt="brandlogo"
              className="cursor-pointer h-16 p-1"
            />
          </div>
        </div>

        <div
          className="flex items-center w-full justify-between text-zinc-700"
          style={{
            width: "82%",
            background: "linear-gradient(180deg, #F5A268, #F70000)",
          }}
        >
          <div className="ml-7">
            {/* <Search className="!border-none" /> */}
          </div>

          <div className="flex items-center justify-center cursor-pointer rounded-md px-3">
            <div
              className="flex items-center justify-center !my-2 cursor-pointer rounded-full px-3"
              style={{
                background: "linear-gradient(90deg, #FFA366,#FFC299)",
              }}
            >
              <div className="flex gap-5 mr-5">
                {/* <Notifications /> */}
                <img src={message} alt="" className="!text-green-500" />
                <div
                  className="w-12 p-1 px-2 flex justify-between rounded-full"
                  style={{
                    background: "linear-gradient(135deg, #F261B7, #D05DEA)",
                  }}
                >
                  <IoMdNotifications className="!text-white" />
                  <span className="text-white text-[12px]">15</span>
                </div>
              </div>
              <div className="flex" onClick={handleClick}>
                {superuserId === "true" ? (
                  <Avatar
                    alt="S"
                    src="broken.jpg"
                    className=" !bg-gray-600 p-2"
                  />
                ) : (
                  <Avatar
                    alt="A"
                    src="broken.jpg"
                    className="!my-2 !h-8 !w-8"
                    style={{
                      background: "linear-gradient(180deg, #A1A1DA, #949DED)",
                    }}
                  />
                )}
                <div className="px-2 py-1 text-zinc-700">
                  {/* <h1 className="font-semibold !text-black">Dashboard</h1> */}
                  <h1 className="text-xs">
                    <span className="text-xs !mt-4 text-slate-300 font-bold">
                      Admin
                    </span>
                    <br />
                    <span className="text-md font-serif">{email}</span>
                  </h1>
                </div>
              </div>

              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className="!absolute !top-3 !right-40 !shadow-sm"
                disableScrollLock
                elevation={10}
              >
                <MenuItem
                  className="hover:!rounded !mx-1"
                  onClick={() => navigate("/dashboard/profile")}
                >
                  Profile
                </MenuItem>
                <MenuItem className="hover:!rounded !mx-1">
                  Account Setting
                </MenuItem>
                <Divider />
                <MenuItem
                  className="hover:!rounded !mx-1"
                  onClick={handleLogout}
                >
                  Logout
                </MenuItem>
              </Menu>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
